import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { EASE } from "@/components/Reveal";

const STATUS_STYLES = {
  "Available in Studio": "bg-sage/15 text-sage border-sage/30",
  "Reserved for Exhibition": "bg-ochre/15 text-ochre border-ochre/30",
  "In Private Collection": "bg-stone2/15 text-stone2 border-stone2/30",
};

export default function ArtworkCard({ art, index = 0, className = "", tall = false }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay: (index % 3) * 0.12, ease: EASE }}
      className={className}
    >
      <Link to={`/artwork/${art.id}`} data-testid={`artwork-card-${art.id}`} className="group block">
        <div className={`relative overflow-hidden bg-cream border border-ink/10 deckle ${tall ? "aspect-[4/5]" : "aspect-[5/4]"}`}>
          <img
            src={art.image}
            alt={`${art.title} — ${art.medium} by Richard Kuensting`}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          <div className="absolute bottom-3 right-3 w-9 h-9 rounded-full bg-paper/90 backdrop-blur flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
            <ArrowUpRight size={16} className="text-ink" />
          </div>
          {art.status !== "Available in Studio" && (
            <span className={`absolute top-3 left-3 font-mono text-[9px] uppercase tracking-[0.2em] px-2.5 py-1 rounded-full border backdrop-blur bg-paper/80 ${STATUS_STYLES[art.status] || ""}`}>
              {art.status}
            </span>
          )}
        </div>
        <div className="mt-4 flex items-start justify-between gap-3">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-sage">{art.series} · {art.year}</p>
            <h3 className="font-serif text-xl sm:text-2xl text-ink mt-1 leading-tight">{art.title}</h3>
          </div>
          <p className="font-mono text-xs text-stone2 whitespace-nowrap mt-1">{art.price_display}</p>
        </div>
      </Link>
    </motion.div>
  );
}
